import { LegalLayout } from "@/components/legal/LegalLayout";

const MesafeliSatisSozlesmesiPage = () => (
  <LegalLayout
    title="Mesafeli Satış Sözleşmesi"
    description="İns Organizasyon ile tüketici arasında kurulan mesafeli satış sözleşmesinin şartlarıdır."
    path="/mesafeli-satis-sozlesmesi"
  >
    <p>
      İşbu sözleşme, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümlerine uygun
      olarak, İns Organizasyon Danışmanlık ve Dış Tic. Ltd. Şti. (“Satıcı”) ile elektronik ortamda hizmet satın alan tüketici
      (“Alıcı”) arasında akdedilmiştir.
    </p>

    <h2>1. Taraflar</h2>
    <p>
      <strong>Satıcı:</strong> İns Organizasyon Danışmanlık ve Dış Tic. Ltd. Şti.<br />
      Adres: Çamlıca Mah. 168. Cad. No: 3 Yenimahalle / Ankara<br />
      Telefon: +90 541 587 88 22<br />
      E-posta: info@insorganizasyon.org<br />
      <strong>Alıcı:</strong> Web sitesi aracılığı ile siparişi tamamlayan gerçek veya tüzel kişi.
    </p>

    <h2>2. Sözleşmenin Konusu</h2>
    <p>
      Satıcıya ait <a href="/">www.insorganizasyon.org</a> internet sitesi üzerinden elektronik ortamda siparişi verilen saha
      operasyonu hizmetlerinin ifası ve bedelinin tahsili ile ilgili olarak tarafların hak ve yükümlülüklerini kapsar.
    </p>

    <h2>3. Hizmetin Özellikleri ve Bedeli</h2>
    <p>
      Hizmete ilişkin temel nitelikler, hizmetin toplam ücreti ve vergiler dahil satış bedeli web sitesinde belirtilmiştir.
      Alıcı tarafından ödeme tamamlandıktan sonra hizmete ilişkin bilgiler e-posta yoluyla teyit edilir.
    </p>

    <h2>4. İfa Süresi</h2>
    <p>
      Hizmet, Alıcı tarafından seçilen operasyon türüne göre ilgili ülke ve sahada belirtilen süre içerisinde başlatılır.
      Öngörülen süre, mücbir sebepler veya sahadaki güvenlik koşulları nedeniyle güncellenebilir ve Alıcı bilgilendirilir.
    </p>

    <h2>5. Cayma Hakkı</h2>
    <p>
      Alıcı, hizmetin ifasına başlanmamış olması koşuluyla 14 gün içerisinde cayma hakkına sahiptir. Cayma bildirimi
      info@insorganizasyon.org adresine yazılı olarak yapılmalıdır. Hizmet ifasına başlanması veya üçüncü kişilere yönelik
      edimlerin tamamlanmış olması halinde cayma hakkı kullanılamayabilir.
    </p>

    <h2>6. İptal ve İade Koşulları</h2>
    <p>
      Cayma hakkının kullanıldığı veya hizmetin ifasının imkânsız hale geldiği durumlarda <a href="/iptal-iade-kosullari">İptal ve
      İade Koşulları</a> uygulanır. İade ödemeleri, talebin onaylanmasını izleyen 14 gün içinde yapılır.
    </p>

    <h2>7. Gizlilik ve Kişisel Verilerin Korunması</h2>
    <p>
      Alıcı tarafından paylaşılan kişisel veriler, KVKK’ya uygun şekilde işlenir ve <a href="/kvkk-basvuru-formu">KVKK Başvuru Formu</a>
      ile haklarınıza ilişkin başvuru yapabilirsiniz.
    </p>

    <h2>8. Uyuşmazlıkların Çözümü</h2>
    <p>
      İşbu sözleşmeden kaynaklanabilecek uyuşmazlıklarda; Ticaret Bakanlığı’nca belirlenen parasal sınırlar dahilinde Tüketici
      Hakem Heyetleri, bu sınırı aşan durumlarda Tüketici Mahkemeleri yetkilidir. Taraflar Ankara Merkez (Çankaya) Mahkemeleri ve
      İcra Müdürlükleri’nin yetkisini kabul eder.
    </p>

    <h2>9. Yürürlük</h2>
    <p>
      Alıcı tarafından elektronik ortamda onaylanan işbu sözleşme yürürlüğe girer. Ödeme işleminin tamamlanması sözleşmenin tüm
      hükümlerinin kabul edildiği anlamına gelir.
    </p>
  </LegalLayout>
);

export default MesafeliSatisSozlesmesiPage;
